/**
 * @description 保單補發動作類型 (enum)
 */
export enum PolicyReissueTypesEnum {
  /** 查詢 */
  Query = '1',
  /** 申請補寄 */
  Apply = '2'
}
